import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import React from 'react';
import {useComputeDefaultState} from '../PriceAndBrand/utils';
import {usePriceAndBrandSection} from '../useGetProductBulkSection';
import {PriceAndBrandHorizontalLoading} from './PriceAndBrandHorizontalLoading';
import {
  PriceAndBrandHorizontalView,
  PriceAndBrandHorizontalViewProps,
} from './PriceAndBrandHorizontalView';

export const PriceAndBrandHorizontal: React.FC<
  PriceAndBrandHorizontalViewProps & PriorityConfig
> = props => {
  const defaultState = useComputeDefaultState(true);

  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={null}
      Loading={() => (
        <PriceAndBrandHorizontalLoading
          className={props.className}
          hideBrandLogo={props.hideBrandLogo}
        />
      )}
      viewProps={props}
      View={PriceAndBrandHorizontalView}
      computeDefaultState={() => defaultState}
      renderingPriority={props.renderingPriority}
    />
  );
};
